<template>
    <div id="supplier_scoring">
        <div class="row">
            <div class="col-sm-12 col-md-4 col-lg-4">
                <supplier-survey-feedback :SupplierID="SupplierId" />
            </div>
        </div>
    </div>
</template>

<script>
import SupplierSurveyFeedback from '../../../components/SupplierSurveyFeedback.vue';
export default {
    name: 'supplier-scoring'
    , props: ['SupplierId']
    , components: {
        SupplierSurveyFeedback
    }
    , data() {
        return {
            supplierId: this.SupplierId
        }
    }
}
</script>

<style scoped>

</style>